export default {
      id: "icon-stardefault-usage",
      viewBox: "0 0 12.67 11.7",
      url: __webpack_public_path__ + "icons.svg#icon-stardefault",
      toString: function () {
        return this.url;
      }
    }